module.exports = __webpack_public_path__ + "img/qr.3917d286.jpg";